import React from 'react';
import { Link } from 'react-router-dom';

function PostCard({ post }) {
  return (
    <div className="group relative flex flex-col bg-white rounded-xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden border border-gray-100 h-full">
      {post.featureImage && (
        <div className="relative overflow-hidden h-48 w-full bg-gray-100">
          <img
            src={post.featureImage}
            alt={post.title + ' feature'}
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        <p className="text-sm font-medium text-blue-600 mb-2">
          {post.date}
        </p>
        <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight group-hover:text-blue-600 transition-colors">
          <Link to={`/post/${post.id}`} className="absolute inset-0 z-10">
            <span className="sr-only">View Post</span>
          </Link>
          {post.title}
        </h3>
        {post.description && (
          <p className="text-gray-600 leading-relaxed text-base line-clamp-3">
            {post.description}
          </p>
        )}
      </div>
    </div>
  );
}

export default PostCard;
